const containerOrder = {
	"container.transport.order.client": "Client",
	"container.transport.order.branch": "Branch",
	"container.transport.order.type": "Type",
	"container.transport.order.clientPo": "Client PO",
	"container.transport.order.port": "Port",
	"container.transport.order.voyage": "Voyage",
	"container.transport.order.terminal": "Terminal",
	"container.transport.order.eta": "ETA",
	"container.transport.order.availability": "Availability",
	"container.transport.order.storageStartDate": "Storage Start Date",
	"container.transport.order.receivalStart": "Receival Start",
	"container.transport.order.generalCutOff": "General Cut Off",
	"container.transport.order.reeferCutOff": "Reefer Cut Off",
	"container.transport.order.masterBill": "Master Bill",
	"container.transport.order.releaseNumber": "Release Number",
	"container.transport.order.shippingLine": "Shipping Line",
	"container.transport.order.dehireLocation": "Dehire Location",
	"container.transport.order.onhireLocation": "Onhire Location",
	"container.transport.order.location": "Location",
	"container.transport.order.unpackLocation": "Unpack Location",
	"container.transport.order.packLocation": "Pack Location",
	"container.transport.order.address": "Address",
	"container.transport.order.suburb": "Suburb",
	"container.transport.order.state": "State",
	"container.transport.order.postcode": "Postcode",
	"container.transport.order.contact": "Contact",
	"container.transport.order.phone": "Phone",
	"container.transport.order.email": "Email",
	"container.transport.order.warehouse": "Warehouse",
	"container.transport.order.specialInstructions": "Special Instructions",
	"container.transport.order.container": "Container",
	"container.transport.order.containerNumber": "Container Number",
	"container.transport.order.sizeType": "Size Type",
	"container.transport.order.isoCode": "ISO Code",
	"container.transport.order.eido": "Pin",
	"container.transport.order.cargoType": "Cargo Type",
	"container.transport.order.dgClass": "DG Class",
	"container.transport.order.unNo": "UN No.",
	"container.transport.order.temperature": "Temperature",
	"container.transport.order.odiem": "ODIEM",
	"container.transport.order.sealNumber": "Seal Number",
	"container.transport.order.gross": "Gross",
	"container.transport.order.requestedFullDelivery": "Requested Full Delivery",
	"container.transport.order.requestedEmptyPickup": "Requested Empty Pickup",
	"container.transport.order.estimatedDetentionDate": "Estimated Detention Date",
	"container.transport.order.requestedEmptyDelivery": "Requested Empty Delivery",
	"container.transport.order.requestedFullPickup": "Requested Full Pickup",
	"container.transport.order.containerComments": "Container Comments",
	"container.transport.order.quantity": "Quantity",
	"container.transport.order.reset": "Reset",
	"container.transport.order.save": "Save",
	"container.transport.order.addContainer": "Add Container",
	"container.transport.order.addRelease": "Add Release",
	"container.transport.order.close": "Close",
	"container.transport.order.add": "Add",
	"container.transport.order.edit": "Edit",
	"container.transport.order.copy": "Copy",
	"container.transport.order.delete": "Delete"
};

export { containerOrder };
